<template>
    <div class="payment-container">
        <fieldset v-html="html"></fieldset>
    </div>
</template>
<script>
    export default {
        props: { public_id: {default: ''} },
        data: function() {
            return {
                html: ''
            }
        },
        created() {
            this.axios.get(window.gateway_url, { params: {
                public_id: this.public_id
            }}).then((response) => {
                let data  = response.data;
                if (typeof data.content !== 'undefined') {
                    this.html = response.data.content;
                }
            }).catch((error) => {
                myAlert({ message: 'Sorry there was an error with that request. Please contact us.' });
            });
        },
        methods: {},
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
//                this.$eventHub.$off('setPaymentGateways', this.setData);
        },
        components: {
            'txt': require('../../../components/form/text.vue').default
        }
    }
</script>